import { useState } from "react";
import api from "../../lib/api";
import { ArrowRight, Check } from "lucide-react";

export default function Newsletter({ compact = false, source = "homepage" }) {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setStatus("loading");
        try {
            await api.post("/newsletter", { email, source });
            setStatus("success");
            setEmail("");
        } catch (e) {
            setStatus("idle");
            setError(
                e.response?.data?.detail
                    ? typeof e.response.data.detail === "string"
                        ? e.response.data.detail
                        : "Please use a valid email."
                    : "Something went wrong. Try again.",
            );
        }
    };

    return (
        <form
            onSubmit={submit}
            data-testid="newsletter-form"
            className={`flex flex-col gap-2 ${compact ? "" : "max-w-md"}`}
        >
            <div className="flex items-stretch bg-white rounded-full border border-kblborder p-1 focus-within:border-kblink transition-colors">
                <input
                    type="email"
                    required
                    placeholder="you@petparent.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="newsletter-email-input"
                    className="flex-1 bg-transparent px-4 py-2.5 text-sm text-kblink focus:outline-none placeholder:text-kblmuted/60 autofill:!text-kblink"
                />
                <button
                    type="submit"
                    disabled={status === "loading" || status === "success"}
                    data-testid="newsletter-submit-button"
                    className="bg-kblink text-white text-sm font-semibold px-5 rounded-full hover:bg-kblcoral transition-colors flex items-center gap-1.5 disabled:opacity-60"
                >
                    {status === "success" ? (
                        <>
                            <Check className="w-4 h-4" /> Subscribed
                        </>
                    ) : (
                        <>
                            Join <ArrowRight className="w-4 h-4" />
                        </>
                    )}
                </button>
            </div>
            {error && (
                <p
                    data-testid="newsletter-error"
                    className="text-xs text-kblcoraldeep px-3"
                >
                    {error}
                </p>
            )}
            {status === "success" && (
                <p
                    data-testid="newsletter-success"
                    className="text-xs text-emerald-700 px-3"
                >
                    You're in! Watch your inbox for next week's picks.
                </p>
            )}
            {!compact && (
                <p className="text-xs text-kblmuted px-3">
                    No spam. One curated email per week. Unsubscribe any time.
                </p>
            )}
        </form>
    );
}
